import React from 'react';
import '../services/ConsoleHelper.js';

const LoadingScreen = () => {
  return (
    <div className="fixed inset-0 flex justify-center items-center z-[1000]">
      {/* Background Video */}
      <video
        className="absolute inset-0 w-full h-full object-cover z-[-1] opacity-80"
        autoPlay
        loop
        muted
        playsInline
      >
        <source src="/background-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      <div className="absolute inset-0 bg-black/50 flex justify-center items-center">
        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-100 max-w-[16rem] w-[90%] flex flex-col items-center justify-center animate-fadeIn">
          <div className="mb-4 text-center">
            <div className="inline-block">
              <span className="text-2xl font-bold text-primary">A<sup>3</sup></span>
              <p className="mt-0.5 text-xs italic text-primaryLight">One Space, Infinite possibilities.</p>
            </div>
          </div>
          
          {/* SVG Spinner - More reliable across browsers */}
          <div className="mb-5">
            <svg className="w-12 h-12 animate-spin" viewBox="0 0 24 24">
              <circle 
                className="opacity-25" 
                cx="12" 
                cy="12" 
                r="10" 
                stroke="currentColor" 
                strokeWidth="4"
                fill="none"
              ></circle>
              <path 
                className="opacity-75" 
                fill="currentColor" 
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              ></path>
            </svg>
          </div>
          
          <p className="text-base font-medium text-primary">Loading...</p>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;